import { createSlice } from "@reduxjs/toolkit";
import { bindActionCreators } from "redux";
import { useDispatch } from "react-redux";
import {
    GetPortalUserActionPayload,
    GetPortalUsersActionPayload,
    PortalUsersState,
} from "../types/portal-users";

const initialState: PortalUsersState = {
    getPortalUsers: {
        data: undefined,
        loading: false,
        success: false,
        error: false,
    },
    getPortalUser: {
        data: undefined,
        loading: false,
        success: false,
        error: false,
    },
};

const portalUsersSlice = createSlice({
    name: "portalUsers",
    initialState,
    reducers: {
        getPortalUsers(state, action: GetPortalUsersActionPayload) {
            state.getPortalUsers = {
                data: undefined,
                loading: true,
                success: false,
                error: false,
            };
        },
        getPortalUsersSuccess(state, actions) {
            state.getPortalUsers = {
                data: actions.payload,
                loading: false,
                success: true,
                error: false,
            };
        },
        getPortalUsersFailure(state) {
            state.getPortalUsers = {
                data: undefined,
                loading: false,
                success: false,
                error: true,
            };
        },
        getPortalUser(state, action: GetPortalUserActionPayload) {
            state.getPortalUser = {
                data: undefined,
                loading: true,
                success: false,
                error: false,
            };
        },
        getPortalUserSuccess(state, actions) {
            state.getPortalUser = {
                data: actions.payload,
                loading: false,
                success: true,
                error: false,
            };
        },
        getPortalUserFailure(state) {
            state.getPortalUser = {
                data: undefined,
                loading: false,
                success: false,
                error: true,
            };
        },
    },
});

export const {
    getPortalUsers,
    getPortalUsersSuccess,
    getPortalUsersFailure,
    getPortalUser,
    getPortalUserSuccess,
    getPortalUserFailure,
} = portalUsersSlice.actions;

export const mapDispatchToProps = () => {
    return bindActionCreators({ getPortalUsers, getPortalUser }, useDispatch());
};

export default portalUsersSlice.reducer;
